import React, { ReactElement, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";

import MenuItem from "@mui/material/MenuItem";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import AppModal from "components/shared/modal/AppModal";

const ShowApi = ({
 s3Url,
 bucketKey,
 secret
}: {
 s3Url: string;
 bucketKey: string;
 secret: string;
}): ReactElement => {
 const intl = useIntl();

 const [open, setOpen] = useState<boolean>(false);

 const handleOpen = () => setOpen(true);
 const handleClose = () => setOpen(false);

 return (
  <>
   <MenuItem onClick={() => handleOpen()}>
    <FormattedMessage id="addons.cloudbucket.showApi" />
   </MenuItem>
   <AppModal
    open={open}
    close={handleClose}
    title={intl.formatMessage({ id: "addons.cloudbucket.showApi" })}
    handleClose={handleClose}
    handleConfirm={handleClose}
    showConfirmButton={false}>
    <Stack spacing={2}>
     <Typography>
      <FormattedMessage id="addons.cloudbucket.showApiMessage" />
     </Typography>
     <Stack spacing={1}>
      <Stack direction="row">
       <Typography variant="subtitle2" fontWeight="bold" minWidth={80}>
        s3URL:
       </Typography>
       <Typography variant="subtitle2">{s3Url}</Typography>
      </Stack>
      <Stack direction="row">
       <Typography variant="subtitle2" fontWeight="bold" minWidth={80}>
        Key:
       </Typography>
       <Typography variant="subtitle2">{bucketKey}</Typography>
      </Stack>
      <Stack direction="row">
       <Typography variant="subtitle2" fontWeight="bold" minWidth={80}>
        Secret:
       </Typography>
       <Typography variant="subtitle2">{secret}</Typography>
      </Stack>
     </Stack>
    </Stack>
   </AppModal>
  </>
 );
};

export default ShowApi;
